/** Display name used to find and remove previously auto-seeded layers. */
export const CHICKFILA_LOCATIONS_LAYER_NAME = 'Chick-fil-A Locations';
